<template>
  <v-card>
    <v-card-title class="i-dialog-header-div">
      <span class="g-heading-m g-bold">Product Archiving</span>
    </v-card-title>

    <v-card-text class="text-center py-6">
      <span v-if="inFamilyGroup(product)" class="mb-2">
        Product will be removed from Family Group and immediately archived.
      </span>
      <span v-else class="mb-2"> Product will be immediately archived. </span>
      <template v-if="!!hasPromos(product)">
        <span class="mt-4" v-if="promosQtyByStatus(product, ACTIVE) > 0">
          {{ promosQtyByStatus(product, ACTIVE) }} Active Promotion(s) will be
          deleted.
        </span>
        <span class="mt-4" v-if="promosQtyByStatus(product, UPCOMING) > 0">
          {{ promosQtyByStatus(product, UPCOMING) }} Upcoming Promotion(s) will
          be deleted.
        </span>
      </template>
      <span class="mt-4">Do you want to Archive this product?</span>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="i-dialog-actions-div justify-center">
      <v-btn rounded text class="i-btn-text-black" @click="handleCancel">
        <strong>Cancel</strong>
      </v-btn>

      <v-btn
        rounded
        class="i-btn-block-secondary"
        :loading="archiving"
        @click="handleArchive"
      >
        <strong>Archive</strong>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
const PROMO_STATUSES = {
  ACTIVE: 'ACTIVE',
  UPCOMING: 'UPCOMING'
}

export default {
  props: {
    archiving: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    ...PROMO_STATUSES
  }),

  methods: {
    handleCancel() {
      this.$emit('cancel')
    },

    handleArchive() {
      this.$emit('confirm', this.product)
    },

    inFamilyGroup(product) {
      return !!product?.familyGroup
    },

    hasPromos(product) {
      if (!product) return false
      return (
        product.activeOrFuturePromotions?.length ||
        product.activeOrFutureVolumePromotions?.length ||
        product.activeOrFutureBuyGetFreePromotions?.length
      )
    },

    promosQtyByStatus(product, status) {
      if (!product) return 0
      return (
        this.specialsQtyByStatus(product, status) +
        this.volPromosQtyByStatus(product, status) +
        this.buyGetQtyByStatus(product, status)
      )
    },

    specialsQtyByStatus(product, status) {
      /*
        This one includes Specials and PriceDrops
        In the future, if required we may need to separate them
      */
      if (!product) return 0
      const qty = product.activeOrFuturePromotions.filter(
        (special) => special.status === status
      )
      return qty.length
    },

    volPromosQtyByStatus(product, status) {
      if (!product) return 0
      const qty = product.activeOrFutureVolumePromotions.filter(
        (volumePromo) => volumePromo.status === status
      )
      return qty.length
    },

    buyGetQtyByStatus(product, status) {
      if (!product) return 0
      const qty = product.activeOrFutureBuyGetFreePromotions.filter(
        (buyGetPromo) => buyGetPromo.status === status
      )
      return qty.length
    }
  },

  mounted() {}
}
</script>
